var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.0008 21.8758L15.8038 16.4623M15.8038 16.4623C17.2104 14.9971 18.0006 13.0099 18.0006 10.9378C18.0006 8.86571 17.2104 6.8785 15.8038 5.41331C14.3972 3.94813 12.4895 3.125 10.5003 3.125C8.51108 3.125 6.60336 3.94813 5.19678 5.41331C3.79021 6.8785 3 8.86571 3 10.9378C3 13.0099 3.79021 14.9971 5.19678 16.4623C6.60336 17.9275 8.51108 18.7506 10.5003 18.7506C12.4895 18.7506 14.3972 17.9275 15.8038 16.4623Z",
    stroke: "#221AFB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.256a8456266b613df1c5bb3aa9122409.svg";
export { ForwardRef as ReactComponent };